import { render, staticRenderFns } from "./ControlBtn.vue?vue&type=template&id=31be3d18"
import script from "./ControlBtn.vue?vue&type=script&lang=js"
export * from "./ControlBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports